import { api as deliveryApi, configs as deliveryConfigs } from './delivery'
import useBbbAllPeriodMetric, {
  bbbAllPeriodMetricConfigs,
} from './useAllPeriodMetric'
import useBbbCorporateInventory, {
  bbbCorporateInventoryConfigs,
} from './useCorporateInventory'
import useBbbCorporatePurchase, {
  bbbCorporatePurchaseConfigs,
} from './useCorporatePurchase'
import useBbbFlash, { bbbFlashConfigs } from './useFlash'
import useBbbLatestItemPrice, {
  bbbLatestItemPriceConfigs,
} from './useLatestItemPrice'
import useBbbLocationList, { bbbLocationListConfigs } from './useLocationList'
import useBbbLocationPurchase, {
  bbbLocationPurchaseConfigs,
  useBbbLocationPurchaseWithSpecificItems,
} from './useLocationPurchase'
import useBbbLocationPurchaseByCategory, {
  bbbLocationPurchaseByCategoryConfigs,
} from './useLocationPurchaseByCategory'
import useBbbOpsDashboard, { bbbOpsDashboardConfigs } from './useOpsDashboard'
import useBbbPAndL, { bbbPAndLConfigs } from './usePAndL'
import useBbbPnlRankings, { bbbPnlRankingsConfigs } from './usePnLRankings'
import useBbbProfitAfterControllables, {
  bbbProfitAfterControllablesConfigs,
} from './useProfitAfterControllables'
import useBibibopRankings, { bibibopRankingsConfigs } from './useRankings'
import useBbbSystemwideOverview, {
  bbbSystemwideOverviewConfigs,
} from './useSystemwideOverview'
import useBbbTrendLocationPurchase, {
  bbbTrendLocationPurchaseConfigs,
} from './useTrendLocationPurchase'
import useBbbTrendPeriodMetric, {
  bbbTrendPeriodMetricConfigs,
} from './useTrendPeriodMetric'

export const configs = {
  ...deliveryConfigs,
  bbbSystemwideOverview: bbbSystemwideOverviewConfigs,
  bbbFlash: bbbFlashConfigs,
  bbbPAndL: bbbPAndLConfigs,
  bbbProfitAfterControllables: bbbProfitAfterControllablesConfigs,
  bbbTrendPeriodMetric: bbbTrendPeriodMetricConfigs,
  bbbAllPeriodMetric: bbbAllPeriodMetricConfigs,
  bbbPnlRankings: bbbPnlRankingsConfigs,
  bbbLocationList: bbbLocationListConfigs,
  bbbOpsDashboard: bbbOpsDashboardConfigs,
  bbbRankings: bibibopRankingsConfigs,
  bbbCorporatePurchase: bbbCorporatePurchaseConfigs,
  bbbCorporateInventory: bbbCorporateInventoryConfigs,
  bbbLocationPurchase: bbbLocationPurchaseConfigs,
  bbbLocationPurchaseWithSpecificItems: bbbLocationPurchaseConfigs,
  bbbTrendLocationPurchase: bbbTrendLocationPurchaseConfigs,
  bbbLocationPurchaseByCategory: bbbLocationPurchaseByCategoryConfigs,
  bbbLatestItemPrice: bbbLatestItemPriceConfigs,
}

export const api = {
  ...deliveryApi,
  bbbSystemwideOverview: useBbbSystemwideOverview,
  bbbFlash: useBbbFlash,
  bbbPAndL: useBbbPAndL,
  bbbProfitAfterControllables: useBbbProfitAfterControllables,
  bbbTrendPeriodMetric: useBbbTrendPeriodMetric,
  bbbAllPeriodMetric: useBbbAllPeriodMetric,
  bbbPnlRankings: useBbbPnlRankings,
  bbbLocationList: useBbbLocationList,
  bbbOpsDashboard: useBbbOpsDashboard,
  bbbRankings: useBibibopRankings,
  bbbCorporatePurchase: useBbbCorporatePurchase,
  bbbCorporateInventory: useBbbCorporateInventory,
  bbbLocationPurchase: useBbbLocationPurchase,
  bbbLocationPurchaseWithSpecificItems: useBbbLocationPurchaseWithSpecificItems,
  bbbTrendLocationPurchase: useBbbTrendLocationPurchase,
  bbbLocationPurchaseByCategory: useBbbLocationPurchaseByCategory,
  bbbLatestItemPrice: useBbbLatestItemPrice,
}
